import Axios from "axios";
import { AuthenticationContext } from "vue-adal";

const url = "https://adminsite-server.azurewebsites.net";
const authorizationHeaders = token => ({
  headers: {
    Authorization: `Bearer ${token}`
  }
});

export const getDefaultEmailRequest = token => Axios.get(`${url}/employees/default`, authorizationHeaders(token));

export const setDefaultEmailRequest = (token, email) =>
  Axios.put(`${url}/employees/default`, { email }, authorizationHeaders(token));

export const getAllOrdersRequest = (token, limit, page) =>
  Axios.get(`${url}/orders`, {
    ...authorizationHeaders(token),
    params: {
      limit,
      page
    }
  });

export const getOneOrderRequest = (token, orderNumber) =>
  Axios.get(`${url}/orders/${orderNumber}`, authorizationHeaders(token));

export const getAllCustomersRequest = token => Axios.get(`${url}/customers`, authorizationHeaders(token));

export const getAllEmployeesRequest = token => Axios.get(`${url}/employees`, authorizationHeaders(token));

export const addEmployeeRequest = (token, { name, email }) =>
  Axios.post(`${url}/employees`, { name, email }, authorizationHeaders(token));

export const updateEmployeeRequest = (token, { employeeID, name, email }) =>
  Axios.put(`${url}/employees`, { employeeID, name, email }, authorizationHeaders(token));

export const deleteEmployeeRequest = (token, { employeeID }) =>
  Axios.delete(`${url}/employees/${employeeID}`, authorizationHeaders(token));

export const postEmployeeToNotifyOnOrderRequest = (token, { dealerNumber, employeeID }) =>
  Axios.post(
    `${url}/customers/notify`,
    { dealer_number: dealerNumber, employee_id: employeeID },
    authorizationHeaders(token)
  );
